import clsx from 'clsx';
import React from 'react';
import parse from 'react-html-parser';

import { Button } from '../../BaseUI';
import { ButtonProps } from '../../BaseUI/Button';
import styles from './styles.module.scss';

enum SubscriptionLength {
  'The Information Pro' = 'Year',
  Annual = 'Year',
  Monthly = 'Month',
  Basic = 'Month',
  'Young Professionals' = 'Year',
}

const SubscriptionOptionCard = ({
  altTitle,
  benefits,
  buttonProps,
  buttonText = 'Subscribe',
  customStyles,
  icon,
  originalPrice,
  price,
  subtitle,
  title,
}: {
  benefits: string[];
  buttonProps: ButtonProps;
  buttonText: string;
  customStyles?: string;
  icon: string;
  price: number;
  altTitle?: 'Basic' | 'Pro';
  title: 'The Information Pro' | 'Annual' | 'Monthly' | 'Young Professionals';
  subtitle?: string;
  originalPrice?: string;
}) => {
  return (
    <div className={clsx(styles.cardContainer, customStyles)}>
      <div className={styles.topBar}></div>
      <div className={styles.cardContent}>
        <img src={icon} alt="subscribe icon" height={30} width={30} />
        <h4 className={styles.header}>{altTitle ? altTitle : title}</h4>
        {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
        <div className={styles.price}>
          ${price}/{SubscriptionLength[title]}
          {originalPrice && parse(originalPrice)}
        </div>
        <Button {...buttonProps}>{buttonText}</Button>
        <ul className={styles.benefitsList}>
          {/* phrases that need to be red should be wrapped in an html tag with class="--red" */}
          {benefits?.length > 0 &&
            benefits.map((benefit, idx) => <li key={idx}>{parse(benefit)}</li>)}
        </ul>
      </div>
    </div>
  );
};

export default SubscriptionOptionCard;
